import React from 'react'
import styled from 'styled-components'
import {useWindowMode} from 'windows'
import {WindowModeType} from 'types'
import {Button, Paragraph, RoboyuConfused} from 'common/components'
import convertUnit from 'lib/unit'
import {TemplateProfileEmptyTabProps} from './TemplateProfileEmptyTabProps'

interface StyledDescProps {
  mode: WindowModeType
}

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: fit-content;
  text-align: center;
  align-self: center;
`

const StyledTitle = styled(Paragraph)``

const StyledDesc = styled(Paragraph)<StyledDescProps>`
  ${({mode}) => ({
    maxWidth: mode === 'website' ? 'initial' : convertUnit(350),
  })}
  width: 100%;
`

const StyledButton = styled(Button)`
  height: ${convertUnit(32)};
  margin-top: ${convertUnit(20)};
`

export default function TemplateProfileEmptyTab({
  buttonLabel,
  description,
  title,
  onClickButton,
  withImage,
}: TemplateProfileEmptyTabProps) {
  const mode = useWindowMode()

  return (
    <StyledContainer>
      {title && (
        <StyledTitle fontSize="l" fontWeight="bold">
          {title}
        </StyledTitle>
      )}
      {description && (
        <StyledDesc mode={mode} fontSize="s" color="gray_5">
          {description}
        </StyledDesc>
      )}
      {buttonLabel && (
        <StyledButton
          color="white_1"
          fontSize="s"
          backgroundColor="primary_5"
          label={buttonLabel}
          onClick={onClickButton}
        />
      )}
      {withImage && (
        <RoboyuConfused
          width={convertUnit(mode === 'website' ? 100 : 70)}
          height={convertUnit(mode === 'website' ? 100 : 70)}
        />
      )}
    </StyledContainer>
  )
}
